(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vayora-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vayora-product-reels')) {
  class VayoraProductReels extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-reel-track]');
      this.dialog = this.querySelector('dialog');
      // The links still open the Shopify file if dialog is unavailable or JS is off.
      if (!this.track || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.cards = [...this.querySelectorAll('[data-reel-card]')];
      if (!this.cards.length) return;
      this.links = this.cards.map(card => card.querySelector('[data-reel-open]'));
      this.stage = this.querySelector('[data-reel-stage]');
      this.error = this.querySelector('[data-reel-error]');
      this.sound = this.querySelector('[data-reel-sound]');
      this.navigation = this.querySelector('[data-reel-navigation]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.links.forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', this.dialog.id);
      });
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-reel-open]');
        if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          this.open(this.links.indexOf(trigger));
        }
        const scroll = event.target.closest('[data-reel-scroll]');
        if (scroll) this.scrollTrack(Number(scroll.dataset.reelScroll));
        const step = event.target.closest('[data-reel-step]');
        if (step) this.showVideo(this.activeIndex + Number(step.dataset.reelStep));
        if (event.target.closest('[data-reel-close]')) this.closePlayer();
        if (event.target.closest('[data-reel-sound]') && this.video) {
          this.video.muted = !this.video.muted;
          this.updateSound();
        }
      }, options);
      this.addEventListener('keydown', event => {
        const trigger = event.target.closest('[data-reel-open]');
        if (trigger && event.key === ' ' && !event.repeat) {
          event.preventDefault();
          this.open(this.links.indexOf(trigger));
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closePlayer();
      }, options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.closePlayer();
      }, options);
      this.dialog.addEventListener('close', () => {
        // A queued close event must not destroy a video opened again in the meantime.
        if (!this.dialog.open) this.cleanup();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'Tab') {
          const controls = [...this.dialog.querySelectorAll('button:not([disabled]), video[controls]')]
            .filter(control => control.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
          return;
        }
        // Leave the native video's seek/volume keyboard shortcuts intact.
        if (event.target.closest('video') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (this.cards.length > 1 && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
          event.preventDefault();
          this.showVideo(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      window.addEventListener('resize', () => this.scheduleUpdate(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video?.pause();
      }, options);
      const wrapper = this.closest('.shopify-section');
      wrapper?.addEventListener('shopify:section:deselect', () => this.closePlayer(), options);
      wrapper?.addEventListener('shopify:section:unload', () => this.closePlayer(false), options);
      this.addEventListener('shopify:block:deselect', () => this.closePlayer(), options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
      }
      this.updateNavigation();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.closePlayer(false);
    }

    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.updateNavigation());
    }

    updateNavigation() {
      if (!this.navigation) return;
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
      this.navigation.hidden = !overflowing;
      const trackRect = this.track.getBoundingClientRect();
      const first = this.cards[0].getBoundingClientRect();
      const last = this.cards[this.cards.length - 1].getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.querySelector('[data-reel-scroll="-1"]').disabled = !overflowing || (rtl ? first.right <= trackRect.right + 5 : first.left >= trackRect.left - 5);
      this.querySelector('[data-reel-scroll="1"]').disabled = !overflowing || (rtl ? last.left >= trackRect.left - 5 : last.right <= trackRect.right + 5);
    }

    scrollTrack(direction) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = this.cards[0].getBoundingClientRect().width + gap;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({ left: distance * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    open(index) {
      if (index < 0 || index >= this.cards.length) return;
      document.querySelectorAll('vayora-product-reels').forEach(section => {
        if (section !== this && section.dialog?.open) section.closePlayer(false);
      });
      this.returnFocus = this.links[index];
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('vayora-reels-lock');
      this.showVideo(index);
      this.querySelector('[data-reel-close]').focus({ preventScroll: true });
    }

    showVideo(index) {
      if (!this.dialog.open) return;
      this.releaseVideo();
      this.activeIndex = (index + this.cards.length) % this.cards.length;
      const card = this.cards[this.activeIndex];
      this.error.hidden = true;
      this.querySelector('[data-reel-dialog-title]').textContent = this.links[this.activeIndex].dataset.reelTitle;
      this.querySelector('[data-reel-counter]').textContent = `${this.activeIndex + 1} / ${this.cards.length}`;
      this.stage.append(card.querySelector('template').content.cloneNode(true));
      const video = this.stage.querySelector('video');
      this.video = video;
      if (!video) return;
      // Every new video starts silent; audio requires an explicit user action.
      video.muted = true;
      this.mediaController = new AbortController();
      const options = { signal: this.mediaController.signal };
      video.addEventListener('error', () => { this.error.hidden = false; }, options);
      video.addEventListener('volumechange', () => this.updateSound(), options);
      this.updateSound();
      video.play().catch(error => {
        if (this.video === video && error.name !== 'AbortError' && error.name !== 'NotAllowedError') this.error.hidden = false;
      });
    }

    updateSound() {
      this.sound.textContent = this.video?.muted ? this.sound.dataset.unmuteLabel : this.sound.dataset.muteLabel;
    }

    releaseVideo() {
      this.mediaController?.abort();
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.remove());
        this.video.load();
        this.video = null;
      }
      this.stage?.replaceChildren();
    }

    closePlayer(restoreFocus = true) {
      if (this.dialog?.open) this.dialog.close();
      this.cleanup(restoreFocus);
    }

    cleanup(restoreFocus = true) {
      this.releaseVideo();
      const anotherOpen = [...document.querySelectorAll('vayora-product-reels dialog')].some(dialog => dialog.open);
      if (!anotherOpen) {
        document.documentElement.classList.remove('vayora-reels-lock');
        if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }
      this.returnFocus = null;
    }
  }
  customElements.define('vayora-product-reels', VayoraProductReels);
}
  } catch(e) { console.error(e); }
})();

})();
